import {
	LinkedinSignalMedia,
	LinkedinSignalPost,
	LinkedinSignalResharedPost,
} from "../../../schema/trackerSignalResult";

export interface SignalPreview {
	id: number;
	status: string;
	priority?: string | null;
	signalCategory?: string | null;
	title?: string | null;
	summary?: string | null;
	sourceUrl?: string | null;
	publishedDate?: string | Date | null;
	reasoning?: string | null;
	errorMessage?: string | null;
	createdAt: string | Date;
	linkedinPostUrn?: string | null;
	linkedinPost?: LinkedinSignalPost | null;
	linkedinCommentary?: string | null;
}

export const getLinkedinPostText = (signal: SignalPreview): string =>
	signal.linkedinPost?.commentary || signal.linkedinCommentary || signal.summary || "";

export const getLinkedinPostUrl = (signal: SignalPreview): string | null =>
	signal.linkedinPost?.share_url || signal.sourceUrl || null;

export const getLinkedinPostDate = (signal: SignalPreview): string | Date | null | undefined =>
	signal.linkedinPost?.postedAt || signal.publishedDate;

export const getLinkedinActorName = (signal: SignalPreview, fallback: string): string =>
	signal.linkedinPost?.actor?.actor_name || signal.title || fallback;

export const getLinkedinPostMedia = (signal: SignalPreview): LinkedinSignalMedia[] =>
	signal.linkedinPost?.media?.filter((item): item is LinkedinSignalMedia => Boolean(item?.url)) ??
	[];

export const getLinkedinResharedPost = (signal: SignalPreview): LinkedinSignalResharedPost | null =>
	signal.linkedinPost?.resharedPost ?? null;
